(function () {
  'use strict';

  var endpoint = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var running = false;

  function showLoader() {
    if (typeof window.showYampiLoader === 'function') {
      window.showYampiLoader();
      return;
    }

    var loader = document.querySelector('.yampi-loader');
    if (loader) loader.style.display = 'block';
  }

  function withUtms(url) {
    if (typeof window.ymp_getUrlWithUtms === 'function') {
      return window.ymp_getUrlWithUtms(url);
    }

    return url;
  }

  function getCheckoutUrl() {
    return fetch('/cart.json', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-read-failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.item_count) return '';

        return fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            shop: window.location.host,
            shopify_internal_domain: (window.Shopify && Shopify.shop) || window.location.host,
            cart_payload: cart
          })
        });
      })
      .then(function (response) {
        if (!response) return '';
        if (!response.ok) throw new Error('yampi-url-failed');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.checkout_direct_url) return '';
        return withUtms(data.checkout_direct_url);
      });
  }

  function goToCheckout(event) {
    if (event) event.preventDefault();
    if (running) return;

    running = true;
    showLoader();

    getCheckoutUrl()
      .then(function (url) {
        window.location.href = url || '/checkout';
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  }

  function isCartPage() {
    return /^\/cart\/?$/i.test(window.location.pathname);
  }

  function init() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"], .cart-recap__checkout, .ymp_check_mainBtn');
      if (!target) return;
      goToCheckout(event);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches('form[action="/cart"], form[action^="/cart"]')) return;

      var submitter = event.submitter || document.activeElement;
      if (submitter && submitter.name === 'checkout') {
        goToCheckout(event);
      }
    }, true);

    if (isCartPage()) {
      window.setTimeout(goToCheckout, 80);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
